import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAY_BENEFIT_CARD_INFO_URL, PAY_BENEFIT_CARD_INFO_MOBILE_URL} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

/**
 * 페이 혜택카드 안내 페이지로 이동
 */
const navigateToPayBenefitCardInfo = createAsyncThunk<NavigationResult, NavigationTypeSelectableParam | void, ThunkApi>(
    'navigateTo/payBenefitCardInfo',
    async (args) => {
        const {forceLocationChange = false} = args ?? {}
        const shouldChangeLocation = forceLocationChange || isMobile

        if (shouldChangeLocation) {
            changeBrowserLocation({url: PAY_BENEFIT_CARD_INFO_MOBILE_URL, type: 'PUSH'})
            // page 이동은 그 자체로 추가동작 없이 resolve 된다
            return Promise.resolve()
        }

        openNewTab({url: PAY_BENEFIT_CARD_INFO_URL})
        return Promise.resolve()
    },
)

export default navigateToPayBenefitCardInfo
